import React from 'react';
import styled from 'styled-components';

export default function Narratives({ data }) {
  if (!data) {
    return null;
  }
  const { success_story, success_story_images = [], lesson_learned } = data;
  const displayLesson = lesson_learned && lesson_learned !== '' ? lesson_learned : 'No lessons learned yet';
  return (
    <Container>
      <Table>
        <Heading>
          <h2>Narratives</h2>
        </Heading>
        <TableRow>
          <div>
            <Title>Success Stories</Title>
            {success_story ?? 'No success stories yet'}
            <Row>
              {success_story_images.map(url => (
                <ImageStory key={url} src={url}/>
              ))}
            </Row>
          </div>
          <div>
            <Title>Lessons Learned</Title>
            {displayLesson}
          </div>
        </TableRow>
      </Table>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
`;

const Table = styled.div`
  width: 100%;
  background-color: #FFFFFF;
  border: solid 1px #ccd7e3;
  border-radius: 4px;
`;

const Heading = styled.div`
  h2 {
    padding: 20px;
    color: #595959;
    font-size: 24px;
    font-weight: 700;
    border-bottom: 1px solid #DADCE0;
  }
`;

const TableRow = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  color: #595959;
  & > div {
    flex: 1;
    padding: 20px;
  }
  & > div:first-child {
    border-right: 1px solid #DADCE0;;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
`;

const Row = styled.div`
  display: flex;
`;

const ImageStory = styled.img`
  width: 100%;
`;
